import * as React from "react";
export const PrePacksLazyRenderContext = React.createContext({});
PrePacksLazyRenderContext.displayName = "PrePacksLazyRenderContext";
//# sourceMappingURL=PrePacksLazyRenderContext.js.map